/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PaymentResponseDto
 */
export interface PaymentResponseDto {
    /**
     * Payment unique identifier
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'id': string;
    /**
     * User ID who made the payment
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'userId': string;
    /**
     * Participation ID this payment is for
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'participationId': string;
    /**
     * Payment type
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'type': PaymentResponseDtoTypeEnum;
    /**
     * Symph Pay product identifier
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'symphPayProductId': string;
    /**
     * Payment status
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'status': PaymentResponseDtoStatusEnum;
    /**
     * Payment amount in the local currency
     * @type {number}
     * @memberof PaymentResponseDto
     */
    'amount': number;
    /**
     * Currency code
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'currency': string;
    /**
     * Additional payment details
     * @type {object}
     * @memberof PaymentResponseDto
     */
    'paymentDetails': object;
    /**
     * Payment creation date in UTC
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'createdAt': string;
    /**
     * Payment last update date in UTC
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'updatedAt': string;
}

export const PaymentResponseDtoTypeEnum = {
    EventRegistration: 'EVENT_REGISTRATION'
} as const;

export type PaymentResponseDtoTypeEnum = typeof PaymentResponseDtoTypeEnum[keyof typeof PaymentResponseDtoTypeEnum];
export const PaymentResponseDtoStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Expired: 'expired'
} as const;

export type PaymentResponseDtoStatusEnum = typeof PaymentResponseDtoStatusEnum[keyof typeof PaymentResponseDtoStatusEnum];


